import * as R from 'ramda';
import { of } from 'rxjs';
import { AjaxError } from 'rxjs/ajax';
// import { map } from 'rxjs/operators';
import { notAuthorized } from './actions';

const createErrorStream = (failedAction, ...actionCreators) => (error, stream) => {
  const actions = actionCreators.map(action => action(error, stream));

  if (R.is(AjaxError, error)) {
    const errorAction = {
      // 400: () => BadRequest(response),
      401: () => notAuthorized(failedAction),
      // 404: () => NotFound(),
      // 500: () => ServiceUnavailable(),
    }[error.status];

    if (errorAction) {
      actions.push(errorAction());
    }
  }

  return of(...actions);
};

export default createErrorStream;
